import { COLUMN_TYPES } from "Boards/const";

export function transformSaveCellShapeToRowShape(columnType, val) {
  switch (columnType) {
    case COLUMN_TYPES.BOOL:
      return `${Number(val.value)}`;
    case COLUMN_TYPES.TEXT:
      return val.value;
    case COLUMN_TYPES.NUMBER:
      return `${val.value}`;
    case COLUMN_TYPES.EXTENDED_FIELDS_TEXT:
    case COLUMN_TYPES.EXTENDED_FIELDS_DATE:
    case COLUMN_TYPES.EXTENDED_FIELDS_ADDRESS:
    case COLUMN_TYPES.EXTENDED_FIELDS_SELECT_LIST:
    case COLUMN_TYPES.EXTENDED_FIELDS_MEMBERSHIP_STATUS:
    case COLUMN_TYPES.EXTENDED_FIELDS_FILE:
      return JSON.stringify(val);
    case COLUMN_TYPES.EXTENDED_FIELDS_NUMBER:
      return JSON.stringify({ value: `${val.value}` });
    default:
      console.warn(
        "Not yet implemented a save cell transform for column type: ",
        columnType
      );
      return undefined;
  }
}
